export default "__VITE_ASSET__RjqUKYdI__"